// Không dùng cờ /g: regex global giữ lastIndex giữa các lần .test() → kết quả lệch true/false luân phiên.
export const slugPattern = /^[A-Za-z0-9-_.~]*$/
